import Swiper, { Navigation, Autoplay, EffectCreative } from 'swiper';
import 'swiper/css';

Swiper.use([Navigation, Autoplay, EffectCreative]);

const galleryCarousel = () => {
  var hs = new Swiper('.gallery-swiper', {
    grabCursor: true,
    effect: 'creative',
    speed: 800,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    creativeEffect: {
      prev: {
        shadow: true,
        translate: ['-120%', 0, -500],
      },
      next: {
        shadow: true,
        translate: ['120%', 0, -500],
      },
    },
  });
};

export default galleryCarousel;
